import themeGet from '@styled-system/theme-get';
import styled from 'styled-components';
import {
  Divider,
  Row,
  PlaceholderGroup,
  TextPlaceholder,
} from '../../../shared/SkeletonComponents/SkeletonComponents';

const TileDigestsSkeleton = () => {
  const isLoading = true;

  return (
    <>
      <Wrapper>
        <Row>
          <PlaceholderGroup>
            <TextPlaceholder width="95px" isLoading={isLoading} />
            <TextPlaceholder
              width="42px"
              margin="0 0 0 9px"
              isLoading={isLoading}
            />
          </PlaceholderGroup>
          <PlaceholderGroup>
            <TextPlaceholder width="96px" isLoading={isLoading} />
            <TextPlaceholder
              width="96px"
              margin="0 0 0 24px"
              isLoading={isLoading}
            />
          </PlaceholderGroup>
        </Row>
        <Divider />
        <Row>
          <TextPlaceholder width="180px" isLoading={isLoading} />
          <PlaceholderGroup>
            <TextPlaceholder width="42px" isLoading={isLoading} />
            <TextPlaceholder
              width="42px"
              margin="0 0 0 77px"
              isLoading={isLoading}
            />
          </PlaceholderGroup>
        </Row>
        <Divider />
        <Row>
          <TextPlaceholder width="180px" isLoading={isLoading} />
          <PlaceholderGroup>
            <TextPlaceholder width="42px" isLoading={isLoading} />
            <TextPlaceholder
              width="42px"
              margin="0 0 0 77px"
              isLoading={isLoading}
            />
          </PlaceholderGroup>
        </Row>
        <Divider />
        <Row>
          <TextPlaceholder width="71px" isLoading={isLoading} />
          <PlaceholderGroup>
            <TextPlaceholder width="42px" isLoading={isLoading} />
            <TextPlaceholder
              width="42px"
              margin="0 0 0 77px"
              isLoading={isLoading}
            />
          </PlaceholderGroup>
        </Row>
        <Divider />
        <Row marginBottom="5px">
          <TextPlaceholder width="154px" isLoading={isLoading} />
        </Row>
        <Row marginBottom="32px">
          <TextPlaceholder width="95px" isLoading={isLoading} />
        </Row>
        <Row>
          <PlaceholderGroup>
            <TextPlaceholder width="117px" isLoading={isLoading} />
            <TextPlaceholder
              width="76px"
              margin="0 0 0 8px"
              isLoading={isLoading}
            />
          </PlaceholderGroup>
          <PlaceholderGroup>
            <TextPlaceholder width="96px" isLoading={isLoading} />
            <TextPlaceholder
              width="96px"
              margin="0 0 0 23px"
              isLoading={isLoading}
            />
          </PlaceholderGroup>
        </Row>
        <Divider />
        <Row>
          <TextPlaceholder width="124px" isLoading={isLoading} />
          <PlaceholderGroup>
            <TextPlaceholder width="42px" isLoading={isLoading} />
            <TextPlaceholder
              width="42px"
              margin="0 0 0 77px"
              isLoading={isLoading}
            />
          </PlaceholderGroup>
        </Row>
        <Divider />
        <Row marginBottom="5px">
          <TextPlaceholder width="128px" isLoading={isLoading} />
        </Row>
        <Row marginBottom="5px">
          <TextPlaceholder width="128px" isLoading={isLoading} />
        </Row>
        <TextPlaceholder width="128px" margin="0 auto" isLoading={isLoading} />
      </Wrapper>
      <Wrapper>
        <Row>
          <PlaceholderGroup>
            <TextPlaceholder width="105px" isLoading={isLoading} />
            <TextPlaceholder
              width="42px"
              margin="0 0 0 8px"
              isLoading={isLoading}
            />
          </PlaceholderGroup>
          <PlaceholderGroup>
            <TextPlaceholder width="96px" isLoading={isLoading} />
            <TextPlaceholder
              width="96px"
              margin="0 0 0 23px"
              isLoading={isLoading}
            />
          </PlaceholderGroup>
        </Row>
        <Divider />
        <Row>
          <TextPlaceholder width="170px" isLoading={isLoading} />
          <PlaceholderGroup>
            <TextPlaceholder width="42px" isLoading={isLoading} />
            <TextPlaceholder
              width="42px"
              margin="0 0 0 77px"
              isLoading={isLoading}
            />
          </PlaceholderGroup>
        </Row>
        <Divider />
        <Row marginBottom="5px">
          <TextPlaceholder width="128px" isLoading={isLoading} />
        </Row>
        <Row marginBottom="5px">
          <TextPlaceholder width="128px" isLoading={isLoading} />
        </Row>
        <TextPlaceholder width="128px" margin="0 auto" isLoading={isLoading} />
      </Wrapper>
    </>
  );
};

export default TileDigestsSkeleton;

const Wrapper = styled.div`
  background-color: ${themeGet('colors.white')};
  margin: 24px;
  padding: 16px;
  border: 1px solid ${themeGet('colors.black.10')};
  border-radius: 8px;
`;
